import { put } from 'redux-saga/effects';
import { raiseHandNotificationUpdateRequested } from 'features/notifications/actions';

export function* onHandRaiseDismissedSaga() {
  yield put(raiseHandNotificationUpdateRequested({ reason: 'hand-dismissed' }));
}
